module.exports = global["p2"] = require("-!.\\p2.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/p2.js
// module id = 30
// module chunks = 0